import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-webapp-seemore-dialog-c001-user',
  templateUrl: './webapp-seemore-dialog-c001-user.component.html',
  styleUrls: ['./webapp-seemore-dialog-c001-user.component.scss']
})
export class WebappSeemoreDialogC001UserComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data ,// get data price-list
    public dialogRef: MatDialogRef<WebappSeemoreDialogC001UserComponent>,//khởi tạo component dưới dạng dialog
  ) { }

  ngOnInit(): void {
    console.log(this.data)
  }
  back(){
    this.dialogRef.close()
  }

}
